import { School } from '../../schools/models/school.model';
import { SchoolRole } from '../../school-users/models/school-user.model';

export type UserRole = 'admin' | 'user';

export interface UserSchool extends School {
  schoolRole: SchoolRole;
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  schools: UserSchool[];
  lastLoginAt: string | null;
}

export interface SchoolMembershipData {
  schoolId: string;
  schoolRole: SchoolRole;
}

export interface UserData {
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  schoolMemberships: SchoolMembershipData[];
}

/** The columns `GET /users` sorts by; `name` is surname first. */
export const USER_SORT_PROPERTIES = ['name', 'email', 'role', 'lastLoginAt'] as const;
export type UserSortProperty = (typeof USER_SORT_PROPERTIES)[number];

export interface UserSort {
  property: UserSortProperty;
  direction: 'asc' | 'desc';
}

/** The page's selection, as the query params carry it; an unset part is `undefined`. */
export interface UserListSelection {
  search?: string;
  schoolId?: string;
  schoolRole?: SchoolRole;
  role?: UserRole;
  sort?: UserSort;
  page: number;
}

export const UserRoleNames: Record<UserRole, string> = {
  user: 'Uživatel',
  admin: 'Administrátor',
};

export interface SchoolAdminMessageData {
  schoolIds: string[];
  subject: string;
  body: string;
}

/** How many admins got the message, and the addresses the mail server refused. */
export interface SchoolAdminMessageResult {
  deliveredCount: number;
  undeliveredEmails: string[];
}
